// extracted by mini-css-extract-plugin
module.exports = {"container":"cohereaffiliatepayouts_container__12gP3","container_norefer":"cohereaffiliatepayouts_container_norefer__290dD"};